// api.js
import axios from "axios";
import { setupInterceptors } from "./axiosInterceptors";

const baseURL = process.env.REACT_APP_BASE_URL + "/api";

const Api = axios.create({
  baseURL,
  withCredentials: true,
}); 

setupInterceptors(Api, baseURL);

export default Api;

// Also export a generic callApi helper if you want
export const callApi = async ({ method, url, body, headers = {} }) => {

  try {
    const response =
      method === "get" || method === "delete"
        ? await Api({ method, url, headers })
        : await Api({ method, url, data: body, headers });

    return response.data;
  } catch (err) {
    console.error("❌ API Error:", err?.response?.data || err.message);
    throw err;
  }
};
